import {
  createFetchAndCacheAtom,
  createFetchAndCacheAtomWithKey,
} from "@mostrans/web-components/helpers/atomHelpers";

export const EmployeeDemographyAtom = createFetchAndCacheAtom([]);
export const EmployeeDemographyAdminAtom = createFetchAndCacheAtom([]);
export const DemographyCategoryAtom = createFetchAndCacheAtom([]);
export const DetailEmployeeDemographyAtom = createFetchAndCacheAtomWithKey([]);
